// extracted by mini-css-extract-plugin
export default {"centeredTextBlock":"T86zJxnEMOjDECKEPEuy","largeIcon":"wpujMWoY4wLF98XIAlHc"};